const toastThemes = {
	INFO: 'info',
	CONFIRM_SUCCESS: 'confirm-success',
	ERROR_OCCURED: 'error-occured',
};

function verifyTheme(theme) {
	return Object.values(toastThemes).includes(theme) ? theme : toastThemes.INFO;
}

const themes = {
	toastThemes,
	verifyTheme,
};

export default themes;
